var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound82A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M24 52a6 6 0 1 1 12 0 6 6 0 0 1-12 0ZM24 28a6 6 0 1 1 12 0 6 6 0 0 1-12 0ZM16.5 57.5A2.5 2.5 0 0 1 19 60v11.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 4 71.5v-14h12.5ZM16.5 40a2.5 2.5 0 0 1 2.5 2.5V54a2.5 2.5 0 0 1-2.5 2.5H4v-14A2.5 2.5 0 0 1 6.5 40h10ZM16.5 22.5A2.5 2.5 0 0 1 19 25v11.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 4 36.5v-14h12.5ZM16.5 5A2.5 2.5 0 0 1 19 7.5V19a2.5 2.5 0 0 1-2.5 2.5H4v-14A2.5 2.5 0 0 1 6.5 5h10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M14 5H6.5A2.5 2.5 0 0 0 4 7.5v64A2.5 2.5 0 0 0 6.5 74H14"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M43.5 21.5A2.5 2.5 0 0 1 41 19V7.5A2.5 2.5 0 0 1 43.5 5h10A2.5 2.5 0 0 1 56 7.5v14H43.5ZM43.5 39a2.5 2.5 0 0 1-2.5-2.5V25a2.5 2.5 0 0 1 2.5-2.5H56v14a2.5 2.5 0 0 1-2.5 2.5h-10ZM43.5 56.5A2.5 2.5 0 0 1 41 54V42.5a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v14H43.5ZM43.5 74a2.5 2.5 0 0 1-2.5-2.5V60a2.5 2.5 0 0 1 2.5-2.5H56v14a2.5 2.5 0 0 1-2.5 2.5h-10Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M46 74h7.5a2.5 2.5 0 0 0 2.5-2.5v-64A2.5 2.5 0 0 0 53.5 5H46"
})));
SvgRound82A.viewBox = '0 0 60 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound82A);
export default ForwardRef;